// extracted by mini-css-extract-plugin
export default {"wrapper":"Ages-module__wrapper___xnjQe"};